import React from "react";
import { Form, Button } from "react-bootstrap";
import "./LoginPage.scss";
export default function LoginPage() {
  return (
    <div className="login">
      <div className="login__form">
        <Form>
          <Form.Label className="label">
            Login Email:
            <Form.Control className="mb-3" type="email"></Form.Control>
          </Form.Label>
          <Form.Label className="label">
            Password:
            <Form.Control className="mb-3" type="password"></Form.Control>
          </Form.Label>
          <Button className="login__form-button">Submit</Button>
        </Form>
      </div>
    </div>
  );
}
